import { Practitioner } from 'src/models';

export const getPractitionerName = (practitioner: Partial<Practitioner>) => {
  if (!practitioner) {
    return null;
  }

  return (
    practitioner.full_name ||
    [
      practitioner.title && `${practitioner.title}.`,
      practitioner.first_name,
      practitioner.last_name,
    ]
      .filter(Boolean)
      .join(' ')
  );
};
